<template>
	<input class="enter-text-field" title="input-phone" type="text" @keyup="searchFunc(user.phone)" @focus="fill" @blur="clean"
					 v-model="user.phone" v-mask="'380#########'" maxlength="12" :placeholder="placeholder"/>
</template>
<script>
	export default {
		name: "InputPhone",
		props: ['user', 'search', 'placeholder'],
		computed: {
			searchFunc() {
				if (this.search !== undefined) {
					return this.search
				}

				return this.fictitious
			}
		},
		methods: {
			fill() {
				if (!this.user.phone)
					this.user.phone = '380'
			},
			clean() {
				if (this.user.phone === '380')
					this.user.phone = ''
			},
			fictitious() {
			}
		}
	}
</script>
<style></style>



// WEBPACK FOOTER //
// InputPhone.vue?7d7ab06a